import goTopButton from '@/components/GoTopButton'
import { showAccountDetails, showCardDetails, showOrderDetails, showBeneficiaryDetails, showOperationDetails } from '@/tools/utils.js'

export default {

  components: {
    goTopButton
  },

  data () {
    return {
      responseErr: null,
      isProcessing: false,
      account: null,
      operations: null
    }
  },

  created () {
    this.account = this.$store.state.accounts.account
    if (!this.account) {
      this.$store.dispatch('accounts/invalidData', 'ACCOUNT_EMPTY')
      this.$router.push({ name: 'account-list' })
    }
    else {
      this.$store.dispatch('accounts/resetInvalidData')
      if (this.account.singleFunderAccount && !this.account.beneficiaryServiceRef) {
        this.getFunderAccountDetails(this.account)
      }
      else {
        this.getBeneficiaryAccountDetails(this.account)
      }
    }

  },

  methods: {
    async getBeneficiaryAccountDetails (account) {
      this.isProcessing = true
      this.responseErr = null

      await this.$store.dispatch('accounts/detailReset')
      await this.$store.dispatch('accounts/getBeneficiaryAccountDetails', {
        accountHierarchyNumber: account.accountHierarchyNumber,
        distributorRef: account.distributorRef,
        beneficiaryServiceRef: account.beneficiaryServiceRef,
        issuerId: this.getIssuerId(account.distributorRef)
      }).then(
        () => {
          this.isProcessing = false
        },
        error => {
          this.isProcessing = false
          this.responseErr = error || 'BAD_REQUEST'
        }
      )
    },

    async getFunderAccountDetails (account) {
      this.isProcessing = true
      this.responseErr = null

      await this.$store.dispatch('accounts/detailReset')
      await this.$store.dispatch('accounts/getFunderAccountDetails', {
        accountHierarchyNumber: account.accountHierarchyNumber,
        distributorRef: account.distributorRef,
        beneficiaryServiceRef: account.beneficiaryServiceRef,
        issuerId: this.getIssuerId(account.distributorRef)
      }).then(
        () => {
          this.isProcessing = false
        },
        error => {
          this.isProcessing = false
          this.responseErr = error || 'BAD_REQUEST'
        }
      )
    },

    getIssuerId (distrRef) {
      const user = JSON.parse(sessionStorage.getItem('user'))
      return Object.keys(user.comProductsMap[distrRef])[0]
    },

    getReasonsForStatus (voucher) {
      var status = null
      var reasons = null

      if (voucher.status != null) {
        status = voucher.status
      } else {
        status = '--'
      }

      if (voucher.reasonsForStatus != null) {
        reasons = voucher.reasonsForStatus
      } else {
        reasons = '--'
      }

      return status + ' / ' + reasons
    },

    updateOperations (operations) {
      this.operations = operations
    },

    showOperation (operation) {
      this.$store.dispatch('operations/setOperation', {
        operationId: operation.operationId,
        operationClass: operation.operationClass,
        distributorRef: this.account.distributorRef,
        beneficiaryServiceRef: this.account.beneficiaryServiceRef,
        issuerId: this.getIssuerId(this.account.distributorRef)
      })
      return showOperationDetails()
    },

    showAccount (accountDetailsPageContext) {
      this.$store.dispatch('accounts/setAccount', {
        accountHierarchyNumber: accountDetailsPageContext[0],
        distributorRef: this.account.distributorRef,
        beneficiaryServiceRef: accountDetailsPageContext[2],
        issuerId: accountDetailsPageContext[1]
      })
      return showAccountDetails()
    },

    showAccountMulti (accountParam) {
      this.$store.dispatch('accounts/setAccount', {
        accountHierarchyNumber: accountParam.accountNumber,
        distributorRef: this.account.distributorRef,
        beneficiaryServiceRef: accountParam.beneficiaryServiceRef,
        issuerId: accountParam.issuerId
      })
      return this.getDetail(this.$store.state.accounts.account)
    },

    showBeneficiary (beneficiaryServiceContext) {
      this.$store.dispatch('beneficiaries/setBeneficiaryService', {
        beneficiaryServiceRef: beneficiaryServiceContext[0],
        distributorRef: beneficiaryServiceContext[1],
        funderContractRef: beneficiaryServiceContext[2],
        issuerId: this.getIssuerId(this.account.distributorRef)
      })
      return showBeneficiaryDetails()
    },

    showCard (card) {
      this.$store.dispatch('cards/setCard', { card: card })
      return showCardDetails()
    },

    showOrder (order) {
      this.$store.dispatch('orders/setOrder', order)
      return showOrderDetails()
    }
  }
}
